import React, { useState } from 'react';
import { api, salvarSessao } from '../api';
import { Campo } from '../components/Base';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  async function entrar(e) {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      const r = await api('/login', { method: 'POST', body: { email, senha } });
      salvarSessao(r);
      window.location.hash = '#/painel';
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    } catch (err) {
      setErro(err.message);
    } finally {
      setCarregando(false);
    }
  }

  return (
    <div className="login">
      <form className="cartao" onSubmit={entrar}>
        <h1>Controla Banheiros</h1>
        <p>Painel de controle</p>
        {erro && <div className="erro-msg">{erro}</div>}
        <Campo label="E-mail">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} autoFocus autoComplete="username" required />
        </Campo>
        <Campo label="Senha">
          <input type="password" value={senha} onChange={e => setSenha(e.target.value)} autoComplete="current-password" required />
        </Campo>
        <button className="btn" style={{ width: '100%' }} disabled={carregando}>{carregando ? 'Entrando…' : 'Entrar'}</button>
      </form>
    </div>
  );
}
